import AdminCrud from "@/components/AdminCrud";

export default function AdminCommittees() {
  return (
    <AdminCrud
      endpoint="/committees"
      singular="committee"
      testIdPrefix="admin-committees"
      listColumns={[
        { key: "name", label: "Name" },
        { key: "chair", label: "Chair" },
        { key: "meeting_cadence", label: "Meets" },
      ]}
      fields={[
        { key: "name", label: "Name", type: "text", required: true, colSpan: 2 },
        { key: "focus", label: "Focus", type: "text", required: true, colSpan: 2 },
        { key: "chair", label: "Chair", type: "text", required: true },
        { key: "meeting_cadence", label: "Meeting cadence", type: "text" },
        { key: "description", label: "Description", type: "textarea", required: true, colSpan: 2, rows: 5 },
      ]}
    />
  );
}
